import { SFC } from "react";
import * as React from "react";
import "./LoadingSpinner.css";

export const LoadingSpinner: SFC<any> = () => {

  return (
  <div className="LoadingSpinner">
    <div/>
    <div/>
    <div/>
    <div/>
    <div/>
    <div/>
    <div/>
  </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.tsx